import ResetPasswordForm from "components/pages/auth/form/ResetPasswordForm";
import React from "react";
import logo from "assets/images/evoke_logo.png";

import { useVerifyTokenQuery } from "app/store/auth/api/resetPasswordApi";
import LoadingSpinner from "components/LoadingSpinner";

import Prohibited from "containers/Prohibited";
import { useLocation } from "react-router";
import { Box, Grid, Typography } from "@mui/material";

const ResetUserPassword = () => {
  const { search } = useLocation();
  const token = new URLSearchParams(search).get("token");
  const { isLoading, error, isError } = useVerifyTokenQuery(token);

  if (
    isError ||
    error?.message === "Unable to processed forgot password" ||
    error?.message === "jwt expired"
  ) {
    return (
      <Prohibited
        title="Password Reset Link Expired"
        content="The password reset link has expired. Please try a new password reset."
      />
    );
  }

  if (isLoading) {
    return (
      <Grid
        justifyContent="center"
        alignItems="center"
        direction="column"
        style={{ height: "100%", display: "flex" }}
      >
        <LoadingSpinner height={80} width="400px" />
        <Typography style={{ marginTop: "10px" }}>Loading...</Typography>
      </Grid>
    );
  }

  return (
    <>
      <Box display="flex" justifyContent="center" alignItems="center" my={10}>
        <img
          src={logo}
          alt="logo"
          style={{ height: 60, maxWidth: "100%", objectFit: "contain" }}
        />
      </Box>
      <ResetPasswordForm />
    </>
  );
};

export default ResetUserPassword;
